import { Container } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import styled from 'styled-components';
import { Fade } from 'react-reveal';
function Events2() {
  return (
    <ContainerUI>
        <Fade up>

        <form action="/">
            <input type="text" placeholder='Keyword'/>


            <select id="eventtype" name="eventtype">
            <option value="category" disabled selected>Choose a Category</option>
            <option value="conference">Conference</option>
            <option value="festival-fair">Festival or Fair</option>
            <option value="Games-competition">Games of Competition</option>
            <option value="Workshop">Workshop</option>
            <option value="other">Other</option>
            </select>

            <input type="address" placeholder='Location'/>
            <input type="date" placeholder='Date' /> 
            <button type='submit'><SearchIcon/>Search</button>
            
        </form>
        </Fade>
    </ContainerUI>
  )
}

export default Events2

const ContainerUI = styled(Container)`
margin-top: 50px;

        form{
            display:grid ;
            justify-content:center ;
            align-items: center;
            align-content:center ;
            grid-template-columns:repeat(auto-fill,minmax(200px,1fr)) ;

        }
        input:nth-child(1){
            border-radius:10px 0 0 10px ;
        }
        input:nth-child(4){
            border-radius:0 10px 10px 0 ;
        }



        input,select,button{
            height:50px ;
            background-color: white;
            outline:none ;
            padding-left:10px ;
            border:none ;
            border-right:1px solid gray ;
        }
        
        button{
            border:none ;
            background-color:#fa7525 ;
            border-radius:10px ;
            color:white ;
            &:hover{
                color:#fa7525 ;
                background-color:black ;

            }

            margin-left:10px ;
            margin-right:10px ;
        }
        @media (max-width:1050px){
            input,select{
              margin:10px ;
              border-radius:10px ;
            }
            input:nth-child(1){
            border-radius:10px;
            }
            input:nth-child(4){
                border-radius:10px;
            }

        }


`